module.exports = __webpack_public_path__ + "static/media/yalcincetin.173b35c1.png";